const normalizeIdList = (ids = []) =>
  ids
    .map((id) => Number(id) || id)
    .filter((id) => id !== undefined && id !== null && id !== "");

export const buildContactsQueryParams = ({
  searchParam,
  pageNumber,
  pageSize,
  sortBy,
  sortDirection,
  selectedTags = [],
  whatsappIds = [],
  walletIds = [],
  walletStatus,
  date,
  dateStart,
  dateEnd,
} = {}) => {
  const params = {};

  if (searchParam) {
    params.searchParam = searchParam;
  }

  if (pageNumber) {
    params.pageNumber = pageNumber;
  }

  if (pageSize) {
    params.pageSize = pageSize;
  }

  if (sortBy) {
    params.sortBy = sortBy;
  }

  if (sortDirection) {
    params.sortDirection = sortDirection;
  }

  if (date) {
    params.date = date;
  }

  if (dateStart) {
    params.dateStart = dateStart;
  }

  if (dateEnd) {
    params.dateEnd = dateEnd;
  }

  if (Array.isArray(selectedTags) && selectedTags.length > 0) {
    params.contactTag = JSON.stringify(normalizeIdList(selectedTags));
  }

  if (Array.isArray(whatsappIds) && whatsappIds.length > 0) {
    params.whatsappIds = JSON.stringify(normalizeIdList(whatsappIds));
  }

  if (walletStatus === "assigned" || walletStatus === "unassigned") {
    params.walletStatus = walletStatus;
  }

  if (Array.isArray(walletIds) && walletIds.length > 0) {
    params.walletIds = JSON.stringify(normalizeIdList(walletIds));
  }

  return params;
};

export default buildContactsQueryParams;
